export default __webpack_public_path__ + "static/media/uncheck-box.f3a5bee1.svg";